import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from '../api-service.service';
import { CommonDropdownSearchComponent } from '../common-component-dropdown-search/common-component-dropdown-search.component';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { SystemActivityLogInfoComponent } from '../system-activity-log-info/system-activity-log-info.component';
@Component({
  selector: 'app-device-system-activity-log',
  templateUrl: './device-system-activity-log.component.html',
  styleUrls: ['./device-system-activity-log.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    MatIcon,
    NgxPaginationModule,
    ReactiveFormsModule,
    DatePipe,
    CommonPaginationComponent,
    CommonSearchComponent,
    CommonDropdownSearchComponent,
    SystemActivityLogInfoComponent,
  ],
})
export class DeviceSystemActivityLogComponent implements OnInit {
  isUploaded = false;

  form: FormGroup = this.formBuilder.group({});

  size = 10;
  page = 1;
  searchText = '';
  filter = '';
  totalLength = 0;
  filterList = [
    { key: 'All', value: '' },
    { key: 'FUT_RTC', value: 'FUT_RTC' },
    { key: 'PST_RTC', value: 'PST_RTC' },
    { key: 'SACK', value: 'SACK' },
    { key: 'PrimaryIp', value: 'PrimaryIp' },
    { key: 'SecondaryIp', value: 'SecondaryIp' },
    { key: 'VIN', value: 'VIN' },
    { key: 'UIN', value: 'UIN' },
    { key: 'WIRE_CUT_CRST', value: 'WIRE_CUT_CRST' },
    { key: 'DNF', value: 'DNF' },
    { key: 'MAIN_VTG', value: 'MAIN_VTG' },
    { key: 'INT_BAT_VTG', value: 'INT_BAT_VTG' },
    { key: 'LAT_LONG', value: 'LAT_LONG' },
    { key: 'UNKNOWN', value: 'UNKNOWN' },
  ];
  Responses = [];

  userPermission = [];

  isDownloading = false;

  private storageListener = (event: StorageEvent) => {
    if (event.key === 'downloadInProgress') {
      this.isDownloading = event.newValue === 'true';
    }
  };
  constructor(
    private formBuilder: FormBuilder,
    public apiMicroservice: ApiServiceService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.setDeviceStateConfigForm();
    this.syncInitialDownloadState();
  }

  syncInitialDownloadState() {
    // sync initial download state across tabs
    this.isDownloading = localStorage.getItem('downloadInProgress') === 'true';
    window.addEventListener('storage', this.storageListener);
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (
          element.pageName === 'Device System Activity Log' &&
          element.view === false
        ) {
          this.navigateBack();
        }
        if (
          element.pageName === 'Device System Activity Log' &&
          element.view === true
        ) {
          this.getDeviceSystemActivityLog();
        }
      }
    );
  }

  setDeviceStateConfigForm() {
    this.form = this.formBuilder.group({
      search: new FormControl(''),
      filter: new FormControl(''),
    });
  }

  getDeviceSystemActivityLog() {
    this.spinner.show();
    this.apiMicroservice
      .getDeviceSystemActivityLog(
        this.page,
        this.size,
        this.searchText,
        this.filter
      )
      .subscribe((res) => {
        if (res.status) {
          this.spinner.hide();
          this.Responses = res.data.data;
          this.totalLength = res.data.totalItems;
          this.apiMicroservice.openSnackbar('Fetched Successfully');
        } else {
          this.spinner.hide();
          this.apiMicroservice.openSnackbar('Something went wrong');
        }
      });
  }

  onPageChange(event: number) {
    this.page = event;
    this.getDeviceSystemActivityLog();
  }

  onSizeChange(event: number) {
    this.page = 1;
    this.size = event;
    this.getDeviceSystemActivityLog();
  }

  onSearch(event: string) {
    this.page = 1;
    this.searchText = event;
    this.form?.get('search')?.setValue(this.searchText ? this.searchText : '');
    this.getDeviceSystemActivityLog();
  }

  onFilter(event) {
    this.page = 1;
    this.filter = event;
    this.form?.get('filter')?.setValue(this.filter ? this.filter : '');
    this.getDeviceSystemActivityLog();
  }

  downloadDeviceSystemActivityLog() {
    // mark download in-progress and notify other tabs
    this.isDownloading = true;
    localStorage.setItem('downloadInProgress', 'true');

    this.apiMicroservice.openSnackbar(
      'Your file is being generated. Refreshing the page or logging out may interrupt the download.'
    );
    this.apiMicroservice
      .downloadDeviceSystemActivityLog(this.searchText, this.filter)
      .subscribe({
        next: (res) => {
          try {
            if (res.status && res.fileDownloadUrl) {
              // window.open(res.fileDownloadUrl, '_blank');
              const link = document.createElement('a');
              link.href = res.fileDownloadUrl;
              link.download = ''; // let browser infer filename
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              this.apiMicroservice.openSnackbar('File Ready for Download.');
            } else {
              this.apiMicroservice.openSnackbar('No data found.');
            }
          } finally {
            // clear in-progress state
            this.isDownloading = false;
            localStorage.setItem('downloadInProgress', 'false');
          }
        },
        error: (err) => {
          console.error(err);
          this.apiMicroservice.openSnackbar('Something went wrong.');
          // clear in-progress state
          this.isDownloading = false;
          localStorage.setItem('downloadInProgress', 'false');
        },
      });
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
